import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function KV({ label, value, mono = false }) {
    return (_jsxs("div", { className: "kv", children: [_jsx("span", { className: "kv__k", children: label }), _jsx("span", { className: mono ? "kv__v kv__v--mono" : "kv__v", children: value })] }));
}
//# sourceMappingURL=KV.js.map